/**
 * Created by swandelow on 02/02/17.
 */
angular.module('CarsSaraBo').directive('notificationsButton', ['$cookies', '$rootScope', 'GAService', function ($cookies, $rootScope, gaService) {
    return {
        scope: {
            language: '@'
        },

        link: function (scope) {
            const NOTIFICATIONS_READ_COOKIE = 'notificationsRead';
            const NOTIFICATIONS_BELL_HAS_BEEN_DISPLAY_COOKIE = 'notificationsBellHasBeenDisplay';

            if (!$cookies.get(NOTIFICATIONS_BELL_HAS_BEEN_DISPLAY_COOKIE)) {
                $cookies.put(NOTIFICATIONS_BELL_HAS_BEEN_DISPLAY_COOKIE, 'true', {expires: new Date("2117")});
                gaService.notify("Autos_MVP_Notificaciones_Grilla", "Imprimir_notificacion", ["Imprimir_notificacion"]);
            }

            scope.showBadge = function () {
                var notificationsReadCookie = $cookies.get(NOTIFICATIONS_READ_COOKIE);
                return !(notificationsReadCookie && notificationsReadCookie === 'true');
            };

            var notification = {
                es: {
                    title: '¡Tenemos novedades!',
                    description: 'Ahora puedes editar el stock de tus vehículos desde la grilla en "Ver diponibilidad y precios".'
                },
                en: {
                    title: 'We have news!',
                    description: 'Now you can edit the stock of your vehicles from the grid in "View availability and prices".'
                },
                pt: {
                    title: 'Temos novidades!',
                    description: 'Agora você pode editar o estoque dos seus veículos na tabela em "Ver disponibilidade e preços".'
                },
                url: 'company/' + $rootScope.getSession().companyOid + '/priceAndAvailability?utm_source=extranet&utm_campaign=autos_notificacion_grilla&utm_medium=notificacion_bell'
            };
            scope.notifications = [notification];

            scope.toggled = function (isOpen) {
                if (isOpen) {
                    gaService.notify("Autos_MVP_Notificaciones_Grilla", "Click_en_campanita", ["Click en campanita"]);
                    var notificationsReadCookie = $cookies.get(NOTIFICATIONS_READ_COOKIE);
                    if (!notificationsReadCookie) {
                        $cookies.put(NOTIFICATIONS_READ_COOKIE, 'true', {expires: new Date("2117")});
                    }
                }
            };

            scope.notifyClickOnNotification = function () {
                gaService.notify("Autos_MVP_Notificaciones_Grilla", "Click_en_notificacion", ["Click en notificación"]);
            }
        },
        templateUrl: 'assets/partial/notifications/notifications.html'
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/notifications_directive.js
// module id = 880
// module chunks = 3